import * as hast from 'hast-util-find-and-replace';

import custom from '@/features/markdown/images/CustomShop-Logo.svg';

const icons = {
  custom,
  myrtic: '/assets/images/rtic/myRTIC-Logo.png',
};

const iconRegex = /(?:icon|logo)::([\w]+)/gi;

export const rehypeIcons = () => {
  const replaceIcon = (value, placeholder) => {
    return icons[placeholder]
      ? [
          {
            type: 'element',
            tagName: 'img',
            properties: {
              src: icons[placeholder],
              class: 'tw-h-[11px]',
            },
          },
        ]
      : null;
  };
  return (tree, _file) => {
    // @ts-ignore
    return hast.findAndReplace(tree, [[iconRegex, replaceIcon]]);
  };
};
